import axios from "@/api/axiosInstance";
import {
  FetchMyProductsHistoryParams,
  FetchMyProductsHistoryResponse,
} from "./types";

export const fetchMyProductsHistory = async (
  params: FetchMyProductsHistoryParams = {},
  signal?: AbortSignal,
): Promise<FetchMyProductsHistoryResponse> => {
  const response = await axios.get<FetchMyProductsHistoryResponse>(
    "/api/private/my/products-history",
    { params, signal },
  );
  return response.data;
};
